const COLORS = {
  grayText: '#414B55',
  gray: '#f8f8f8',
  shadow: '#9F9F9F',
  grayHome: '#B4B4B4',
  testimonialsBackground: '#F8F8F8',
  greenDark: '#01B9A3',
  discount: '#64C07D',
  basket_header: '#0d77d3',
  HOME: {
    ICON1: '#FFE9CB',
    ICON2: '#E3CBFF',
    ICON3: '#CBF1FF',
  },
  price: '#FFC543',
  divider: '#6e7175',
  bestPrice: '#4453A1',
  brand: '#64C07D',
  vendor: ' #6CBFFF',
  orange: '#FFB716',

  //common by theme
  error: '#FF9494',

  backgroundColorWhilistLove: '#f0f0f0',
  backgroundColorProfile: '#fff3d8',
  backgroundColorCart: '#fff3d8',
  backgroundColorLove: '#ffd4d3',
  backgroundLight: '#ffffff',

  buttonBasketPrimary: '#FFC543',
  backgroundButton: '#d7d7d7',
  backgroundBrand: '#FF7E67',
  primaryButtonBackground: '#f2f2f2',
  border: '#dcdcdc',
  border2: '#9F9F9F',
  border3: '#E6E8EB',

  thirty_v2: '#F4F8FF',
  black: '#123456',
  loveSvg: '#ff2826',
  loveWhilistSvg: '#414b55',

  storeDefault: {
    primary: {
      main: '#FFC452',
      light: '#FFF0CB',
      contrastText: '#e19401',
    },
    secondary: {
      main: '#4454A1',
      light: '#86c9f8',
      contrastText: '#FFFBEC',
    },
    background: {},
    text: {},
  },

  viatris: {
    primary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#121c4e',
    },
    secondary: {
      main: '#783B9C',
      light: '#783B9C',
      contrastText: '#E3EED5',
    },
    background: {},
    text: {},
  },
  cos: {
    primary: {
      main: '#77A643',
      light: '#B5D79D',
      contrastText: '#436026',
    },
    secondary: {
      main: '#FBA105',
      light: '#FFF0CB',
      contrastText: '#E3EED5',
    },
    background: {},
    text: {},
  },
  lesOfficinales: {
    primary: {
      main: '#8CA63B',
      light: '#C3D79D',
      contrastText: '#436026',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#E3EED5',
    },
    background: {},
    text: {},
  },
  gcapPharma: {
    primary: {
      main: '#207821',
      light: '#DDEFD0',
      contrastText: '#293324',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#E3EED5',
    },
    background: {},
    text: {},
  },
  centraleMediprix: {
    primary: {
      main: '#E3151F',
      light: '#F8D0D3',
      contrastText: '#7A0B11',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#F9E0E1',
    },
    background: {},
    text: {},
  },
  pharmacologyStore: {
    primary: {
      main: '#CD6B51',
      light: '#F0D5CB',
      contrastText: '#6E3929',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#F5E6E0',
    },
    background: {},
    text: {},
  },
  centraleDpharma: {
    primary: {
      main: '#009BA5',
      light: '#B3E5E9',
      contrastText: '#005459',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#E0F5F7',
    },
    background: {},
    text: {},
  },
  aelia: {
    primary: {
      main: '#036B98',
      light: '#ACD6E8',
      contrastText: '#ACD6E8',
      colot: '#036B98',
    },
    secondary: {
      main: '#EE4B6A',
      light: '#EE4B6A',
      contrastText: '#EAF9FF',
    },
    background: {},
    text: {},
  },

  helloPharmacie: {
    primary: {
      main: '#00A754',
      light: '#B3E8CE',
      contrastText: '#005A2D',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#E0F5E8',
    },
    background: {},
    text: {},
  },
  normandiePharma: {
    primary: {
      main: '#1B6B93',
      light: '#B3D8E8',
      contrastText: '#0D3A50',
    },
    secondary: {
      main: '#213390',
      light: '#D7E8F4',
      contrastText: '#E0EFF5',
    },
    background: {},
    text: {},
  },
  trenteSeptDegres: {
    primary: {
      main: '#002856',
      light: '#B3C7DB',
      contrastText: '#001530',
    },
    secondary: {
      main: '#38D430',
      light: '#C0F0BD',
      contrastText: '#E8F5E8',
    },
    background: {},
    text: {},
  },
  outremer: {
    primary: {
      main: '#0B3D8F',      // Bleu outremer profond — ancre institutionnelle
      light: '#C2D4F0',     // Ciel marin pâle — hover, fonds de sections
      dark: '#072A65',      // Marine nuit — focus, actif
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#00A399',      // Turquoise lagon — maritime sobre, fluidité moderne
      light: '#C0EDE9',     // Eau peu profonde — tags, labels
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#EEF5FF',   // Bleu très pâle — lumière filtrée sur mer
    },
    text: {
      primary: '#0D2454',   // Encre marine profonde
      secondary: '#2A5298', // Bleu institutionnel moyen
    },
  },

  basket: {
    deleteAll: '#FF3F25',
  },
  minOrderPrice: {
    progressColor: '#FFDBD6',
    backgroundColor: '#FFFFFF',
    textColor: '#21938B',
  },
}

export default COLORS
